import React from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const NavigationButtons = ({ currentStep, totalSteps, handlePrevious, handleNext, isSubmitting, isSubmitDisabled = false }) => (
  <div className="mt-6 flex justify-between">
    {currentStep > 0 && (
      <button
        type="button"
        onClick={handlePrevious}
        className="flex items-center px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
      >
        <FaArrowLeft className="mr-2" /> Previous
      </button>
    )}
    {currentStep < totalSteps - 1 && (
      <button
        type="button"
        onClick={handleNext}
        className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 ml-auto"
      >
        Next <FaArrowRight className="ml-2" />
      </button>
    )}
    {currentStep === totalSteps - 1 && (
      <button
        type="submit"
        disabled={isSubmitting || isSubmitDisabled}
        className={`px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 ml-auto text-white ${
          isSubmitting || isSubmitDisabled
            ? 'bg-green-400 cursor-not-allowed opacity-70'
            : 'bg-green-600 hover:bg-green-700'
        }`}
      >
        Submit
      </button>
    )}
  </div>
);

export default NavigationButtons;